import { CalendarEvent } from './CalendarEvent';

import type { Cycle } from './Cycle';

class ReoccuringEvent extends CalendarEvent {
    startDate: Date;
    endDate: Date | null;
    frequency: number;
    cycle: Cycle;
    removedDates: Date[];

    constructor(startDate: Date, endDate: Date | null, frequency: number, cycle: Cycle) {
        super(true);
        this.startDate = startDate;
        this.endDate = endDate;
        this.frequency = frequency;
        this.cycle = cycle;
        this.removedDates = [];
    }

    override occurances(firstDate: Date, lastDate: Date): number {
        if (lastDate < this.startDate || (this.endDate && this.endDate < firstDate)) {
            // Range of the income does not overlap with the range of the year
            return 0;
        }

        // Only get the dates where they overlap
        // The first date should be the more recent of the two
        firstDate = this.startDate < firstDate ? firstDate : new Date(this.startDate);
        if (this.endDate) {
            // The end data should be the oldest of the two
            lastDate = lastDate < this.endDate ? lastDate : new Date(this.endDate);
        }

        const date = this.generateDates(firstDate, lastDate);
        return date.length;
    }

    generateDates(firstDate: Date, lastDate: Date): Date[] {
        const dates = [];
        // Create a copy to preserve the actual start date
        let currentDate = new Date(firstDate);

        while (currentDate <= lastDate) {
            // Create duplicate of date
            dates.push(new Date(currentDate));
            if (this.cycle === "daily") {
                currentDate.setDate(currentDate.getDate() + this.frequency); 
            } else if (this.cycle === "weekly") {
                currentDate.setDate(currentDate.getDate() + 7 * this.frequency); 
            } else if (this.cycle === "monthly") {
                currentDate.setMonth(currentDate.getMonth() + this.frequency);
            } else if (this.cycle === "yearly") {
                currentDate.setFullYear(currentDate.getFullYear() + this.frequency);
            }
        }

        return dates;
    } 

};

export { ReoccuringEvent };